export type EditorConfiguration = {
    blockquote?: boolean;
    code?: boolean;
    headings: boolean;
    horizontalRule?: boolean;
    link?: boolean;
    lists: boolean;
    media?: boolean;
    paragraphs?: boolean;
    resetStyle: boolean;
    table?: boolean;
    textAlignment?: { defaultAlignment: 'left' | 'center' | 'right' };
    textColors: { front?: string[]; back?: string[] };
    textStyle: { bold: boolean; italic: boolean; underline: boolean; strike: boolean };
};

export const DEFAULT_EDITOR_CONFIGURATION: EditorConfiguration = {
    blockquote: true,
    code: true,
    headings: true,
    horizontalRule: true,
    link: true,
    lists: true,
    media: true,
    paragraphs: true,
    resetStyle: true,
    table: true,
    textAlignment: { defaultAlignment: 'left' },
    textColors: {},
    textStyle: {
        bold: true,
        italic: true,
        underline: true,
        strike: true
    }
};
